import React from "react";
import {
    InfoBoxTitle,
    InfoBoxWrapper,
} from "../../../ProductOrder/single/Styled";
import {
    Content,
    ContentItem,
} from "../../../ProductOrder/single/Summary/Styled";
import { sum } from "lodash";
import { formatCurrency } from "../../../../utils/format";
import { Divider } from "@mui/material";

interface SummaryProps {
    data: any[];
}

const Summary = ({ data }: SummaryProps) => {
    const totalPrice = sum(
        data.map((item: any) => item.provider_price * (item.missing_quantity || 0))
    );

    return (
        <InfoBoxWrapper>
            <InfoBoxTitle>Tổng đơn hàng</InfoBoxTitle>
            <Content>
                <ContentItem>Giá vật tư ({data.length} vật tư)</ContentItem>
                <ContentItem>{formatCurrency(totalPrice)}</ContentItem>
            </Content>
            <Divider />
            <Content>
                <ContentItem style={{ fontWeight: "700" }}>
                    Tổng đơn hàng
                </ContentItem>
                <ContentItem style={{ fontWeight: "700" }}>
                    {formatCurrency(totalPrice)}
                </ContentItem>
            </Content>
        </InfoBoxWrapper>
    );
};

export default Summary;
